import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능: 소재혼용율입력 화면
 * 세부설명:
*/

export class MaterialDtl extends Component {
    static displayName = MaterialDtl.name;

    constructor(props) {
        super(props);
        this.state = {
            Title: "",
            GoodsMatalModel: [],
            totalRatio:0
        };
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        this.handleRate_Change = this.handleRate_Change.bind(this);
        this.handleSum_Blur = this.handleSum_Blur.bind(this);
        this.handleSelect_Click = this.handleSelect_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.MaterialCodeDataCall()
    }
    //소쟁유형 조회
    MaterialCodeDataCall() {
        if (this.props.ContentState.GoodsMatalModel !== undefined && this.props.ContentState.GoodsMatalModel !== null) {
            this.setState({ "GoodsMatalModel": this.props.ContentState.GoodsMatalModel });
        }
    }
    handleDelete_Click(event, Matal_Cd) {
        let GoodsMatalModel = this.state.GoodsMatalModel;
        Big3Common.Util.RemoveModelListRow(GoodsMatalModel, "Matal_Cd", Matal_Cd);
        this.setState({ GoodsMatalModel: GoodsMatalModel });
    }
    handleRate_Change(event) {
        let tagId = event.target.id;
        let value = event.target.value.trim();
        let StringText = value.replace(/-/gi, '');
      
        if (Big3Common.Util.isNumber(StringText) === false) {
            return false;
        }
        else {
            let GoodsMatalList = this.state.GoodsMatalModel;
            GoodsMatalList.map(list => {
                if (list.Matal_Cd === tagId) {
                    list.Ratio = value;
                }
                return list;
            });
            this.setState({ GoodsMatalModel: GoodsMatalList })
        }
        return false;
    }
    handleSum_Blur(event) {
        let GoodsMatalList = this.state.GoodsMatalModel;
        let totalRatio = GoodsMatalList.reduce(function (sum, list) {
            return sum + parseInt(list.Ratio === "" ? 0 : list.Ratio);
        }, 0);
        this.setState({ totalRatio: totalRatio });
        return false;
    }
    handleSelect_Click(event) {
        if (this.state.totalRatio !== 100) {
            this.setState({ Title: "혼용률은 합이 100%가 되어야 합니다." });
            Big3Common.ModalAlert(bootstrap, 'MaterialAlert');
            return false;
        }
        let ContentState = this.props.ContentState;
        ContentState.GoodsMatalModel = this.state.GoodsMatalModel;
        this.props.RenderComponent('GoodsReg', ContentState);
        event.preventDefault();
    }
    Materialrender() {
        let ListData = this.state.GoodsMatalModel;
        
        return (
            <div>
                {ListData.map(list =>
                    <div className="Material_input_box" key={list.Matal_Cd}>
                        <label>{list.Matal_Nm}</label>
                        <div className="Material_input">
                            <input type="text"
                                className="form-control"
                                id={list.Matal_Cd}
                                onChange={this.handleRate_Change}
                                onBlur={this.handleSum_Blur}
                                value={list.Ratio}
                                maxLength="3"
                            />%
                        </div>
                        <div className="item_delete" onClick={(e) => { this.handleDelete_Click(e, list.Matal_Cd) } }></div>
                    </div>
                 )}
            </div>
            )
    }
    render() {        
        let Materialrender = this.Materialrender();
        return (
            <div>
                <div className="Material_wrap">
                    <div className="category_slectbox">
                        <div className="title">혼용률 입력</div>
                        {Materialrender}
                        <div className="input_txt">혼용률은 합이 100%가 되어야 합니다. 현재 {this.state.totalRatio}% 입니다. </div>
                    </div>
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handleSelect_Click }>완료</button>
                </div>
                <Alert
                    id="MaterialAlert"
                    title={this.state.Title}
                />
            </div>
        );
    }
}
